import {on} from "../jsbase/events";

var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {},

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function ($rowElem) {
                var rowId = $rowElem.data('day');
                return {id: rowId, el: $rowElem};
            },
            actions: [{
                name: 'Rapporte öffnen',
                classNames: 'dropdown-item',
                iconClass: 'bi-eye',
                onClick: this.onOpenDay,
                isShown: (row) => row.el.is('[data-day]'),
            }, {
                name: 'Rapporte erstellen',
                classNames: 'dropdown-item',
                iconClass: 'bi-plus-circle-fill',
                onClick: this.onAddWorkItem,
                isShown: (row) => row.el.is('[data-day]'),
            }],
        });
        $(this.el).on('onLoaded', this.refreshContextButtons);
    },

    events: [{
        name: 'click',
        el(component) {
            return component.el.querySelectorAll('.btn-context-click');
        },
        handler(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var rowEl = $(ev.target).closest(this.selector);
            this.menu.open(rowEl, ev);
            debugger;
            return false;
        }
    }],

    methods: {
        refreshContextButtons(ev) {
            $(ev.currentTarget).find('.btn-context-click').get().forEach((el) => {
                on(el, 'click', (cev) => {
                    cev.preventDefault();
                    cev.stopPropagation();
                    var rowEl = $(cev.target).closest(this.selector);
                    this.menu.open(rowEl, cev);
                    return false;
                });
            });
        },
        onOpenDay(row) {
            if (row.id) {
                slidein.openUrl($(row.el).attr('data-slidein'));
            }
        },
        onAddWorkItem(row) {
            if (row.id) {
                slidein.openUrl($(row.el).attr('data-slidein') + '&addWorkItem=1');
            }
        },
    },

}
